import React, { useState } from "react";
import NavBar from "../component/NavBar";
import { Image } from "primereact/image";
import { useHistory } from "react-router-dom";
import { WizardAppartamentoVilla } from "../component/WizardAppartamentoVilla";
import LazyLoad from 'react-lazyload';
import ReactGA from "react-ga4";


const PortfolioPage = () => {
  const [tipologia, setTipologia] = useState("");
  const history = useHistory();
  ReactGA.send({ hitType: "pageview", page: "/portfolio", title: "Portfolio" });
  const [visiblePreventivo, setVisiblePreventivo] = useState(false);


  const item = (imgSrc, testo) => {
    return (
      <div className="col-12 md:col-6 lg:col-3 mb-3 lg:mb-0">
        <div className="">
          <div className="relative">
          <LazyLoad height={200} offset={100}>
            <Image
              src={imgSrc}
              alt={testo}
              className="w-full"
              height="350"
              width="300"
              preview
            />
            </LazyLoad>
          </div>
          <div className="flex align-items-center justify-content-between mt-3 mb-2">
            <span className="text-900 font-medium text-xl">{testo}</span>
          </div>
        </div>
      </div>
    );
  };


const itemVideo = (videoSrc, testo, posterUrl,formatoVideo, objectFit) => {
    return (
    <div className="col-12 md:col-6 lg:col-3 mb-3 lg:mb-0">
      <div className="">
        <div className="relative" style={{ height: "350px" }}>
          <LazyLoad height={200} offset={100}>
            <video
              controls
              autoPlay
              loop
              muted
              poster={posterUrl}
              alt={testo}
              className="w-full"
              style={{ height: "350px", width: "100%", objectFit: "cover" , background: "#000"  }}
            >
              <source src={videoSrc} type={formatoVideo} />
              Il tuo browser non supporta il tag video.
            </video>
          </LazyLoad>
        </div>
        <div className="flex align-items-center justify-content-between mt-3 mb-2">
          <span className="text-900 font-medium text-xl">{testo}</span>
        </div>
      </div>
    </div>
  );
  };

           
         

  const openWizardPreventivo = (tipologia) => {
    setVisiblePreventivo(true);
    setTipologia(tipologia);
  };

  return (
    <div>
      <NavBar
        goToContatti={() => history.push("/home#contatti")}
        openPreventivo={(tipologia) => openWizardPreventivo(tipologia)}
      />
      <div className="surface-section px-5 py-4 md:px-5 lg:px-6">
        <div className="text-900 font-medium text-4xl mb-4">Portfolio</div>
        <p className="mt-0 p-0 mb-5 text-600 text-2xl">
          Crediamo in un lavoro eseguito con passione, precisione e cura per i
          dettagli. Collaboriamo a stretto contatto con il cliente, garantendo
          trasparenza nei costi, nei tempi e nella gestione del progetto. Il
          nostro obiettivo è trasformare ogni spazio in un luogo unico e
          funzionale, in grado di rispecchiare la personalità e le esigenze di
          chi lo vive.
        </p>
        {/**portfolio lista foto */}
        <div className="grid ">
          
          {itemVideo("assets/immagini/portfolio/villetta_cassina_pecchi/video_villetta.mp4","Rifacimento Villetta", "assets/immagini/portfolio/villetta_cassina_pecchi/poster_villetta.jpeg" , "video/mp4", "cover")}
          {itemVideo("assets/immagini/portfolio/villetta_cassina_pecchi/video_villetta_interno.mp4","Rifacimento Villetta Interno", "assets/immagini/portfolio/villetta_cassina_pecchi/poster_villetta_interno.jpeg" , "video/mp4", "cover")}
          {itemVideo("assets/immagini/portfolio/piscina/piscina_video_3.mp4","Rifacimento Villetta Interno", "assets/immagini/portfolio/piscina/piscina_video_3.mp4" , "video/mp4", "cover")}
          {item("assets/immagini/portfolio/piscina/piscina_1.jpeg",   "Costruzione Piscina")}          
          {item("assets/immagini/portfolio/piscina/piscina_2.jpeg",   "")}          
          {item("assets/immagini/portfolio/farmacia_1.webp",   "Restyling farmacia")}
          {item("assets/immagini/portfolio/farmacia_2.webp",    "Restyling farmacia")}
          {item("assets/immagini/portfolio/farmacia_3.webp",   "Restyling farmacia")}
          {item("assets/immagini/portfolio/farmacia_4.webp",   "Restyling farmacia")}
          {item("assets/immagini/portfolio/farmacia_5.webp",  "Restyling farmacia")}

          {item("assets/immagini/portfolio/1.webp",  "Rifacimento tetto")}
          {item("assets/immagini/portfolio/8.jpg",  "Rifacimento tetto")}
          {item("assets/immagini/portfolio/10.webp", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/3_0.webp", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/3_1.jfif", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/3_2.webp", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/3_3.webp", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/3_4.webp", "Rifacimento tetto")}
          {item("assets/immagini/portfolio/2.jpg",  "Restyling attività commerciale")}
          {item("assets/immagini/portfolio/3.jpg",  "Restyling attività commerciale")}
          {item("assets/immagini/portfolio/4.jpg",  "Restyling attività commerciale")}
          {item("assets/immagini/portfolio/11_0.jpg",  "Restyling attività commerciale")}
          {item("assets/immagini/portfolio/6.webp",  "Rinnovo facciata villetta")}
          {item("assets/immagini/portfolio/6_1.webp",  "Rinnovo facciata villetta")}
          {item("assets/immagini/portfolio/6_3.webp",  "Rinnovo facciata villetta")}
          {item("assets/immagini/portfolio/13.jpg", "Restauro facciata storica")}
          {item("assets/immagini/portfolio/7.webp",  "Restauro facciata storica")}
          {item("assets/immagini/portfolio/8_0.jfif",  "Restauro facciata storica")}
          {item("assets/immagini/portfolio/11.jpg", "Riqualificazione estetica della facciata condominiale")}
          {item("assets/immagini/portfolio/10_1.jpg", "Riqualificazione estetica della facciata condominiale")}
          {item("assets/immagini/portfolio/10_0.jpg", "Riqualificazione ingresso condominiale")}
          {item("assets/immagini/portfolio/12.webp", "Rinnovo facciata villetta")}
          {item("assets/immagini/portfolio/14.jpg", "Ristrutturazione degli interni")}
          {item("assets/immagini/portfolio/15.jpg", "Ristrutturazione degli interni")}
          {item("assets/immagini/portfolio/12_0.webp", "Ristrutturazione bagno")}
          {item("assets/immagini/portfolio/7_0.jfif", "Ristrutturazione bagno")}
          {item("assets/immagini/portfolio/2_0.jpg", "Costruzione in opera di tavolato forati ")}
          {item("assets/immagini/portfolio/2_1.jpg", "Costruzione in opera di tavolato forati ")}
          {item("assets/immagini/portfolio/2_2.jpg", "Costruzione in opera di tavolato forati ")}
          {item("assets/immagini/portfolio/2_3.jpg", "Costruzione in opera di tavolato forati ")}
          {item("assets/immagini/portfolio/2_4.jpg", "Costruzione in opera di tavolato forati ")}
          {/*{item("assets/immagini/portfolio/2_5.jpg", "Costruzione in opera di tavolato forati ")}*/}
          {item("assets/immagini/portfolio/2_6.jpg", "Costruzione in opera di tavolato forati ")}
        </div>
      </div>
      {visiblePreventivo && (
        <WizardAppartamentoVilla
          tipologia={tipologia}
          onExit={() => setVisiblePreventivo(false)}
        />
      )}
    </div>
  );
};
export default PortfolioPage;
